import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Import your handshake / split visual asset and local brand logos here
import handshakePhoto from '../Assets/slider/1.jpg'; 
import brandPlaceholder from '../Assets/slider/1.jpg'; 

const WhyChooseUs = () => {
  const [hoveredBadgeIdx, setHoveredBadgeIdx] = useState(null);

  // 1. Primary Checklist Data (Exact matches from your image text copy)
  const checklistData = [
    {
      id: 1,
      title: "A great option for busy folks.",
      desc: "Looking up interior designer in Pune to execute your ideas? ST Studio is the perfect answer for busy individuals like yourself. We offer services from the initial design stage to the final on-site execution. With our team of professionals, we are well equipped to bring your ideas to life efficiently, leaving you stress-free!"
    },
    {
      id: 2,
      title: "Smart budget optimization.",
      desc: "Need an expert interior designer in Pune who can help you optimize your budget? Our team is comprised of expert professionals who can advise how to best spend or not spend money before any purchases are made. We understand how important it is to be on a budget; we make sure your funds are used optimally!"
    },
    {
      id: 3,
      title: "Top notch after-sale service.",
      desc: "We are committed to cultivating strong relationships with our clients. We pride ourselves on providing exemplary after-sale service and unwavering support. Our products are built to last, however, if replacement is needed, we send a team right away; this has earned us the reputation of most trusted interior designer in Pune."
    }
  ];

  // 2. Lower Grid Micro-Feature Icon Badges (Exact matches from your image)
  const minorBadges = [
    { id: 1, icon: "✏️", text: "Get Tailored One of a Kind Design Options" },
    { id: 2, icon: "⏳", text: "Receive Handover on Agreed Time" },
    { id: 3, icon: "💡", text: "Get Exclusive Décor Lists from E-Stores" },
    { id: 4, icon: "🚛", text: "Move Ready Support for NRIs*" },
    { id: 5, icon: "📋", text: "Obtain Transparent Modular Estimates" },
    { id: 6, icon: "📜", text: "Enjoy Exceptional 5-Year Warranty*" },
    { id: 7, icon: "  ", text: "Experience Design Evolved in 3D" },
    { id: 8, icon: "🧴", text: "Move In Deep Cleaned Cozy Home" }
  ];

  // 3. Brands We Trust Footer Data
  const trustedBrands = [
    { id: 1, name: 'Häfele', type: 'Premium Hardware', img: brandPlaceholder },
    { id: 2, name: 'Hettich', type: 'Intelligent Fittings', img: brandPlaceholder },
    { id: 3, name: 'Godrej', type: 'Security Systems', img: brandPlaceholder },
    { id: 4, name: 'CenturyPly', type: 'Structural Boarding', img: brandPlaceholder },
    { id: 5, name: 'Blum', type: 'Motion Mechanism', img: brandPlaceholder },
    { id: 6, name: 'Asian Paints', type: 'Pastel Pigments', img: brandPlaceholder }
  ];

  const theme = {
    background: '#F8F6F2',   
    surface: '#FFFFFF',      
    accent: '#D4AF37',       // Champagne Gold
    checkColor: '#4BB543',   // Natural Image Green check mark tone
    textMain: '#2C302E',     
    textMuted: '#7A827E',    
    border: 'rgba(44, 48, 46, 0.08)'
  };

  const inlineStyles = `
    @keyframes slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes loopMarquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
    
    .animate-block-reveal { animation: slideUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    .animate-marquee-track { display: flex; width: max-content; animation: loopMarquee 25s linear infinite; }
    .animate-marquee-track:hover { animation-play-state: paused; }

    @media (max-width: 991px) {
      .screen-padding-box { padding: 30px 20px !important; }
      .main-title-header { font-size: 2rem !important; }
      .split-asymmetric-row { flex-direction: column !important; gap: 40px !important; }
      .split-left-visual { min-width: 100% !important; height: 300px !important; }
      .split-right-list { min-width: 100% !important; }
      .minor-badges-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 20px !important; }
      .brand-marquee-window { display: none !important; }
      .brand-grid-fallback { display: grid !important; grid-template-columns: repeat(2, 1fr) !important; gap: 15px !important; }
    }
  `;

  return (
    <div className="screen-padding-box" style={{
      background: theme.background,
      minHeight: '100vh',
      color: theme.textMain,
      padding: '40px 60px 60px 60px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      boxSizing: 'border-box',
      overflowX: 'hidden'
    }}>
      <style>{inlineStyles}</style>

      {/* Return Link Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
        <Link to="/" style={{ color: theme.textMuted, textDecoration: 'none', fontSize: '0.9rem', letterSpacing: '1px' }}>
          ← Return to Studio
        </Link>
      </div>

      {/* ==================== CENTRALIZED TITLING CONTAINER ==================== */}
      <div style={{ textAlign: 'center', marginBottom: '60px' }}>
        <h1 className="main-title-header" style={{ fontSize: '2.5rem', fontWeight: '400', color: theme.textMain, letterSpacing: '1px', margin: 0, textTransform: 'uppercase' }}>
          Why Choose Our Interior Designers In Pune?
        </h1>
        <div style={{ width: '40px', height: '2px', background: theme.accent, margin: '15px auto 0 auto' }} />
      </div>

      {/* ==================== UPPER BLOCK: HANDSHAKE IMAGE & CHECKLISTS ==================== */}
      <div className="split-asymmetric-row" style={{ display: 'flex', gap: '60px', alignItems: 'flex-start', marginBottom: '80px' }}>
        
        {/* Left Side Handshake / Office Environment Frame */}
        <div className="animate-block-reveal split-left-visual" style={{ flex: '1', minWidth: '340px', height: '480px', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 15px 35px rgba(44,48,46,0.05)' }}>
          <img src={handshakePhoto} alt="Interior Designer Client Agreement Handshake" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>

        {/* Right Side Content Paragraph Checklists */}
        <div className="split-right-list" style={{ flex: '1.2', minWidth: '360px', display: 'flex', flexDirection: 'column', gap: '35px' }}>
          {checklistData.map((item) => (
            <div key={item.id} className="animate-block-reveal" style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
              {/* Image-accurate custom square green check mark icon element */}
              <div style={{
                color: '#FFFFFF',
                background: theme.checkColor,
                fontSize: '0.85rem',
                fontWeight: 'bold',
                width: '20px',
                height: '20px',
                borderRadius: '4px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
                marginTop: '4px'
              }}>
                ✓
              </div>
              <div>
                <h3 style={{ margin: '0 0 10px 0', fontSize: '1.3rem', fontWeight: '600', color: theme.textMain, letterSpacing: '0.3px' }}>
                  {item.title}
                </h3>
                <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.6', color: theme.textMuted }}>
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ==================== MIDDLE BLOCK: 2-ROW UNIQUE MINOR FEATURE BADGES GRID ==================== */}
      <div className="animate-block-reveal" style={{ marginBottom: '80px', borderTop: `1px solid ${theme.border}`, paddingTop: '60px' }}>
        <div className="minor-badges-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '40px 30px',
          textAlign: 'center'
        }}>
          {minorBadges.map((badge, index) => {
            const isHovered = hoveredBadgeIdx === index;
            return (
              <div 
                key={badge.id}
                onMouseEnter={() => setHoveredBadgeIdx(index)}
                onMouseLeave={() => setHoveredBadgeIdx(null)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '15px',
                  padding: '10px',
                  transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
                  transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
                }}
              >
                {/* Visual Icon Node Housing Frame */}
                <div style={{
                  fontSize: '1.6rem',
                  background: isHovered ? 'rgba(214, 175, 55, 0.05)' : theme.surface,
                  border: `1px solid ${isHovered ? theme.accent : theme.border}`,
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.01)',
                  transition: 'all 0.3s ease'
                }}>
                  {badge.icon}
                </div>
                <p style={{
                  margin: 0,
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  lineHeight: '1.4',
                  color: isHovered ? theme.accent : theme.textMain,
                  maxWidth: '180px',
                  transition: 'color 0.3s'
                }}>
                  {badge.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* ==================== LOWER BLOCK: BRANDS WE TRUST SCROLLING DECK BAR ==================== */}
      <div className="animate-block-reveal" style={{ width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '3px', fontSize: '0.8rem', fontWeight: '600', display: 'block', marginBottom: '4px' }}>Ecosystem Partners</span>
          <h2 style={{ fontSize: '1.6rem', fontWeight: '400', margin: '0', letterSpacing: '0.5px' }}>Brands We Trust</h2>
        </div>

        {/* DESKTOP MARQUEE */}
        <div className="brand-marquee-window" style={{ position: 'relative', width: '100vw', margin: '0 -60px', overflow: 'hidden', background: theme.surface, padding: '25px 0', borderTop: `1px solid ${theme.border}`, borderBottom: `1px solid ${theme.border}` }}>
          <div className="animate-marquee-track">
            {[...trustedBrands, ...trustedBrands].map((brand, idx) => (
              <div key={idx} style={{ width: '190px', padding: '0 25px', display: 'flex', alignItems: 'center', gap: '15px', flexShrink: 0, borderRight: `1px solid rgba(44, 48, 46, 0.05)` }}>
                <img src={brand.img} alt={brand.name} style={{ height: '36px', width: '36px', borderRadius: '6px', objectFit: 'cover', filter: 'grayscale(100%) opacity(75%)', transition: 'all 0.3s' }} onMouseEnter={(e) => e.target.style.filter = 'grayscale(0%) opacity(100%)'} onMouseLeave={(e) => e.target.style.filter = 'grayscale(100%) opacity(75%)'} />
                <div style={{ textAlign: 'left' }}>
                  <span style={{ fontSize: '0.85rem', fontWeight: '600', color: theme.textMain, display: 'block', whiteSpace: 'nowrap' }}>{brand.name}</span>
                  <span style={{ fontSize: '0.7rem', color: theme.textMuted, display: 'block', whiteSpace: 'nowrap' }}>{brand.type}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* MOBILE FALLBACK GRID */}
        <div className="brand-grid-fallback" style={{ display: 'none' }}>
          {trustedBrands.map((brand) => (
            <div key={brand.id} style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: '12px', padding: '15px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <img src={brand.img} alt={brand.name} style={{ height: '35px', width: '35px', borderRadius: '6px', objectFit: 'cover', marginBottom: '8px' }} />
              <span style={{ fontSize: '0.85rem', fontWeight: '600', color: theme.textMain }}>{brand.name}</span>
              <span style={{ fontSize: '0.7rem', color: theme.textMuted }}>{brand.type}</span>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default WhyChooseUs;
